module.exports = __webpack_public_path__ + "media/images/star-inactive-4a3dd13c6e30e1217a53c59e2d333298.svg";